import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function NotAuthorized() {
    const { user, signOut } = useAuth();
    return (
        <div className="flex min-h-screen items-center justify-center bg-mm-bg px-5" data-testid="not-authorized">
            <div className="w-full max-w-md text-center">
                <div className="mx-auto mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-amber-800">
                    <ShieldAlert size={26} />
                </div>
                <h1 className="mm-display text-3xl text-mm-navy">You're signed in, but not authorized.</h1>
                <p className="mt-3 text-mm-muted">
                    This area is restricted to Moving Mountains staff.
                    {user ? (
                        <>
                            {" "}You're signed in as <strong>{user.email}</strong> (role: {user.role}).
                        </>
                    ) : null}
                </p>
                <div className="mt-6 flex items-center justify-center gap-3">
                    <Link to="/" className="mm-btn-outline">Back to home</Link>
                    <button onClick={signOut} className="mm-btn-ghost">Sign out</button>
                </div>
            </div>
        </div>
    );
}
